import { render, staticRenderFns } from "./BaseAdmEmpresa.vue?vue&type=template&id=2fdbf660&scoped=true&"
import script from "./BaseAdmEmpresa.vue?vue&type=script&lang=js&"
export * from "./BaseAdmEmpresa.vue?vue&type=script&lang=js&"
import style0 from "./BaseAdmEmpresa.vue?vue&type=style&index=0&id=2fdbf660&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdbf660",
  null
  
)

export default component.exports